import React, { useState, useMemo } from 'react';
import _ from 'lodash';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import PubSub from 'pubsub-js';
import RouterHelper from '../../../core/RouterHelper';
import WhiteLabelController from '../../../core/WhiteLabelController';
import GlobalConst from '../../../utils/GlobalConst';
import { PLATFORM, PLATFORM_LABELS, DISABLED_PLATFORMS, switchPlatform } from './MenuDataProvider';
// import { PLATFORM_THEME } from './MenuDataProvider';
import DropdownSelector from '../../markup/selectors/DropdownSelector';
import Tooltip from '../../markup/Tooltip';
import { AEROIcon } from './img/Icons';
/* global __APP_PLATFORM__ */

const IMPERSONATION_PLATFORM_SWITCH_MSG = 'For security reasons, impersonation is limited to the current platform.<br />To access another platform, initiate impersonation directly from the<br />platform you want to use.';

const ALL_PLATFORM_OPTIONS = [
	// REMOVED UNTIL FURTHER NOTICE, REUSE THE COLOR STUFF FOR THE FUTURE IN CASE WE WANT TO GO BACK TO COLORS IN DROPDOWN
	// { id: PLATFORM.CREATIVE, title: <span style={{ color: PLATFORM_THEME[PLATFORM.CREATIVE].accent }}>{PLATFORM_LABELS[PLATFORM.CREATIVE]}</span>, permMethod: 'canAccessPlatformSwitcherCreativeIq' },
	{ id: PLATFORM.VIEW, title: <span>{PLATFORM_LABELS[PLATFORM.VIEW]}</span>, permMethod: 'canAccessPlatformSwitcherViewIq' },
	{ id: PLATFORM.ACTIVATE, title: <span>{PLATFORM_LABELS[PLATFORM.ACTIVATE]}</span>, permMethod: 'canAccessPlatformSwitcherActivateIq' },
	{ id: PLATFORM.REPORTING, title: <span>{PLATFORM_LABELS[PLATFORM.REPORTING]}</span>, permMethod: 'canAccessPlatformSwitcherReportingIq' },
	{ id: PLATFORM.AERO, title: <AEROIcon />, permMethod: 'canAccessPlatformSwitcherAero' }
];

const PlatformSwitcher = ({ menuExpanded, onPathClick, authUser, impersonating }) => {
	const currentPlatform = useMemo(() => __APP_PLATFORM__, []);
	const [isSwitching, setIsSwitching] = useState(false);
	const favicon = WhiteLabelController.siteAssets.favicon || require('../../../favicon.png');
	// const currentColor = PLATFORM_THEME[currentPlatform]?.accent || "#333";
	const currentLabel = PLATFORM_LABELS[currentPlatform] || "Platform";
	const showImpersonationTooltip = impersonating && authUser?.canAccessPlatformSwitcher;

	const platformOptions = useMemo(() => {
		return ALL_PLATFORM_OPTIONS.filter((opt) => {
			if (opt.id === currentPlatform) return true;
			return !!authUser?.[opt.permMethod];
		});
	}, [authUser, currentPlatform]);

	const handlePlatformChange = (opt) => {
		if (opt === currentPlatform || _.isUndefined(opt)) return;
		else if (impersonating) return;
		setIsSwitching(true);
		switchPlatform({ targetPlatform: opt, currentPlatform })
			.catch(() => {
				PubSub.publish(GlobalConst.SHOW_MODAL_MSG, {
					type: GlobalConst.MODAL_TYPE_ERROR,
					message: { readableMessage: "Failed to switch platform. Please try again." },
					title: "Error switching platform"
				});
			})
			.finally(() => setIsSwitching(false));
	};

	if (menuExpanded) {
		return (
			<Tooltip
				className="platform-switcher-impersonation-tooltip"
				tip={showImpersonationTooltip ? IMPERSONATION_PLATFORM_SWITCH_MSG : ''}
				place="right" html
			>
				<div>
					<div
						className={cx(
							"asset-container platform-switcher-container platform-switcher-wrapper",
							{ "disabled-link": !authUser?.canAccessPlatformSwitcher },
							{ "platform-switcher-impersonating": showImpersonationTooltip }
						)}
					>
						{isSwitching && (
							<div
								className="platform-switcher-overlay"
								style={{ '--option-count': platformOptions.length }}
							>
								<i className="material-icons rotating-i">hourglass_empty</i>
							</div>
						)}
						<DropdownSelector
							id="platform-switcher"
							className="platform-switcher-dropdown"
							options={platformOptions}
							optionsDisabled={DISABLED_PLATFORMS}
							selections={[currentPlatform]}
							onChange={handlePlatformChange}
							idKey="id"
							titleKey="title"
							selectorTitle={<div className="flex-column">
								<span className='iq-series-label'>IQ Series</span>
								<span className="ellipsis-overflow">{currentLabel}</span>
							</div>}
							noSelectedClass
							multiselect={false}
							showChevron={authUser?.canAccessPlatformSwitcher}
							disablePopup={!authUser?.canAccessPlatformSwitcher}
							selectionType="id"
							disableCheckbox
							allowSearch={false}
						/>
					</div>
				</div>
			</Tooltip>
		);
	}

	return (
		<Link to={RouterHelper.takeHome()} onClick={() => onPathClick(RouterHelper.takeHome(), "Dashboard")}>
			<img className="favicon" src={favicon} alt="icon" />
		</Link>
	);
};

PlatformSwitcher.propTypes = {
	menuExpanded: PropTypes.bool.isRequired,
	onPathClick: PropTypes.func.isRequired,
	authUser: PropTypes.object,
	impersonating: PropTypes.bool
};

export default PlatformSwitcher;
